import * as http from "./base";

export async function fetchHistory({
  page = 1,
  sorting,
  searchString = "",
  limit = 25
}) {
  const reqPage = page ? `&page=${page}` : "";
  const reqSorting = sorting
    ? `&order_by=${sorting.value ? sorting.key : `-${sorting.key}`}`
    : "";
  const reqSearch = `&search=${searchString}`;

  return await http.get(
    `mail-piece-status-account/?page_size=${limit}${reqPage}${reqSorting}${reqSearch}`
  );
}
